import { StepProps, Steps } from "antd";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import SearchOrAddSubjectStep from "./SearchOrAddSubjectStep";
import { useAddPolicySubjectContext } from "./AddPolicySubjectContext";
import AddPolicySubjectSummaryStep from "./AddPolicySubjectSummaryStep";
import PersonalDataStep from "./PersonalDataStep";
import ContactsStep from "./ContactsStep";
import AddressesStep from "./AddressesStep";
import PaymentMethodsStep from "./PaymentMethodsStep";

interface IAddPolicySubjectWizardProps {
  onAddPolicySubject: () => void;
}

const AddPolicySubjectWizard = ({
  onAddPolicySubject,
}: IAddPolicySubjectWizardProps) => {
  const { t } = useTranslation();

  const { addPolicySubjectData } = useAddPolicySubjectContext();

  const [current, setCurrent] = useState(0);

  const stepsItems = useMemo(() => {
    const result: StepProps[] = [
      {
        title: t(
          "STEP-TITLE.add-policy-subject-wizard-search-or-add-subject-step-title"
        ),
      },
    ];

    if (addPolicySubjectData) {
      if (addPolicySubjectData.id) {
        // ho scelto un soggetto già esistente
      } else {
        // è un nuovo soggetto
        result.push({
          title: t(
            "STEP-TITLE.add-policy-subject-wizard-subject-personal-data-step-title"
          ),
        });

        result.push({
          title: t(
            "STEP-TITLE.add-policy-subject-wizard-subject-contacts-step-title"
          ),
        });

        result.push({
          title: t(
            "STEP-TITLE.add-policy-subject-wizard-subject-addresses-step-title"
          ),
        });

        result.push({
          title: t(
            "STEP-TITLE.add-policy-subject-wizard-subject-payment-methods-step-title"
          ),
        });
      }

      result.push({
        title: t("STEP-TITLE.add-policy-subject-wizard-summary-step-title"),
      });
    }

    return result;
  }, [addPolicySubjectData]);

  const handleOnNextStep = () => {
    setCurrent(current + 1);
  };

  const handleOnPreviousStep = () => {
    setCurrent(current - 1);
  };

  const subjectSelected = addPolicySubjectData && addPolicySubjectData.id;

  return (
    <>
      <Steps current={current} items={stepsItems} />

      {/* <pre>{JSON.stringify(addPolicySubjectData, null, 2)}</pre> */}

      <div>
        {current === 0 && (
          <SearchOrAddSubjectStep onNextStep={handleOnNextStep} />
        )}

        {subjectSelected ? (
          <>
            {current === 1 && (
              <AddPolicySubjectSummaryStep
                onPreviousStep={handleOnPreviousStep}
                onCreateClaim={onAddPolicySubject}
              />
            )}
          </>
        ) : (
          <>
            {current === 1 && (
              <PersonalDataStep
                onNextStep={handleOnNextStep}
                onPreviousStep={handleOnPreviousStep}
              />
            )}

            {current === 2 && (
              <ContactsStep
                onNextStep={handleOnNextStep}
                onPreviousStep={handleOnPreviousStep}
              />
            )}

            {current === 3 && (
              <AddressesStep
                onNextStep={handleOnNextStep}
                onPreviousStep={handleOnPreviousStep}
              />
            )}

            {current === 4 && (
              <PaymentMethodsStep
                onNextStep={handleOnNextStep}
                onPreviousStep={handleOnPreviousStep}
              />
            )}

            {current === 5 && (
              <AddPolicySubjectSummaryStep
                onPreviousStep={handleOnPreviousStep}
                onCreateClaim={onAddPolicySubject}
              />
            )}
          </>
        )}
      </div>
    </>
  );
};

export default AddPolicySubjectWizard;
